<template>
    <div class="cash-withdrawal" style="padding-top: 1rem">
        <!--<navTitle title="绑定电子钱包"></navTitle>-->
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Link e-wallet'" :path="path"></navTitle>
        <div class="row-wrap">
            <div class="row-T1">Pilih Bank</div>
            <div class="row">
                <div class="row-name">Bank</div>
                <div v-if="my_cash!=''">{{post.sbank_name}}</div>
                <select v-else class="select" :disabled="my_cash==''?false:true" v-model="post.sbank_id">
                    <option value="">Silakan pilih bind bank</option>
                    <option v-for="(item, index) in payList" :key="index" :value="item.id">
                        <!--<img :src="item.icon" alt="">-->

                        {{ item.bank_name }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="showSubmit">
            <div class="row-wrap">
                <div class="row-T1">Detail bank</div>
                <div class="row">
                    <div class="row-name">Akun</div>
                    <input class="input" :disabled="my_cash==''?false:true" placeholder="Masukkan rekening bank Anda"
                           v-model="post.bank_card"/>
                </div>
                <div class="row">
                    <div class="row-name">Nama pemegang</div>
                    <input class="input" placeholder="Masukkan nama asli Anda" v-model="post.bank_holder"
                           :disabled="my_cash==''?false:true"/>
                </div>

                <div class="row">
                    <div class="row-name">Nomor telepon</div>
                    <input class="input" placeholder="Format:8*********" v-model="post.phone"
                           :disabled="my_cash==''?false:true"/>
                </div>
            </div>
            <div class="tips" v-if="my_cash==''">
                *Silakan periksa dan konfirmasi semua detail sudah benar, detail yang salah akan menunda penarikan
            </div>
            <div class="tips" v-else>
                <p>* If you want to bind other account, please contact customer service to unbind.</p>
                <!--<p style="color:red;">* Setelah menetapkan sandi penarikan, Anda dapat menetapkan dan melepaskan kartu
                    bank sendiri <i v-if="is_set_pwd" style="color: #00c3f9" @click="forgetPassword">Lupakan kata
                        sandinya</i></p>-->
            </div>
            <div class="submit bg-color-blue " v-if="my_cash==''" @click="submitted">Bind</div>
            <div class="submit bg-color-blue unbind" v-else>
                Melompat
            </div>
            <!--<div class="submit bg-color-blue unbind" v-else @click="unbindDialog">
                {{is_set_pwd===true?'Nyahikat':'Tetapkan sandi penarikan'}}
            </div>-->
            <!--<div class="submit bg-color-blue" v-if="is_set_pwd" @click="editWithdrawPasswordDialog">Ubah kata sandi
                penarikan
            </div>-->
        </div>
        <div id="forPop" v-if="tx_pwd_bind" @click="bgClose"></div>
        <div v-if="tx_pwd_bind" class="set-pwd">
            <div v-if="!is_set_pwd">
                <div class="tx-pwd-title">Tetapkan sandi penarikan</div>
                <div class="row">
                    <input type="password" class="input" placeholder="Sandi tarik" v-model="withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="Konfirmasi kata sandi"
                           v-model="confirm_withdraw_pwd"/>
                </div>
                <div class="set-tx-pwd-btn bg-color-blue" @click="unbind">Konfirmasi</div>
            </div>
            <div v-else-if="edit_set_pwd">
                <div class="tx-pwd-title">Ubah kata sandi penarikan</div>
                <div class="row">
                    <input type="password" class="input" placeholder="Kata sandi lama" v-model="old_withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="Kata sandi baru" v-model="new_withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="Konfirmasi kata sandi"
                           v-model="confirm_withdraw_pwd"/>
                </div>
                <div class="set-tx-pwd-btn bg-color-blue" @click="editWithdrawPassword">Konfirmasi</div>
            </div>
            <div v-else>
                <div class="tx-pwd-title">Buka ikatan rekening bank ini</div>
                <div class="row">
                    <input type="password" class="input" placeholder="Sandi tarik" v-model="withdraw_pwd"/>
                </div>
                <div class="set-tx-pwd-btn bg-color-blue" @click="unbind">Konfirmasi</div>
            </div>
            <div class="set-tx-pwd-btn bg-qx" @click="bgClose">Tutup</div>
            <div class="forget-password" v-if="is_set_pwd" @click="forgetPassword">Lupa kata sandi penarikan</div>
        </div>
        <div id="fpwd" v-if="forget_pwd" @click="fpwdClose"></div>
        <div v-if="forget_pwd" class="set-pwd">
            <div class="tx-pwd-title">Lupakan kata sandinya</div>
            <div class="row">
                <input type="number" class="input" placeholder="Akun" v-model="forget_pwd_bank_card"/>
            </div>
            <div class="row">
                <input type="password" class="input" placeholder="Kata sandi baru" v-model="new_withdraw_pwd"/>
            </div>
            <div class="row">
                <input type="password" class="input" placeholder="Konfirmasi kata sandi"
                       v-model="confirm_withdraw_pwd"/>
            </div>
            <div class="set-tx-pwd-btn bg-color-blue" @click="resetPwd">Konfirmasi</div>
            <div class="set-tx-pwd-btn bg-qx" @click="fpwdClose">Tutup</div>
        </div>
    </div>
</template>
<script>
    import {
        recharge_bind_cash,
        withdraw_info,
        recharge_ubind_cash,
        getWithdrawPasswordFlag,
        createWithdrawPassword,
        editWithdrawPassword,
        unbindWallet,
        resetWithdrawPassword
    } from "../../api/user";
    import navTitle from "@components/navTitle";

    export default {
        name: "myPay",
        components: {navTitle},
        props: {},
        watch: {
            cashName(n, o) {
                // console.log(n, o);
                let list = this.my_cash;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].type == n) {
                        this.select_cash = list[i];
                        this.showSubmit = false;
                        return;
                    }
                }
                this.showSubmit = true;
            }
        },
        data: function () {
            return {
                icon_moeny: this.global.moeny,
                payList: {},
                my_cash: [], //已经绑定的电子钱包
                select_cash: [],
                path:'/user',
                forget_pwd: false,
                tx_pwd_bind: false,
                edit_set_pwd: false,
                forget_pwd_bank_card: '',
                is_set_pwd: '',
                withdraw_pwd: '',
                confirm_withdraw_pwd: '',
                old_withdraw_pwd: '',
                new_withdraw_pwd: '',

                showSubmit: true, //默认显示新增绑定
                cashName: "",
                post: {
                    phone: "",
                    bank_card: "",
                    bank_holder: "",
                    sbank_id: "",
                    sbank_name: '',
                },
                removeData: {},
                banks: ["Gcash", "juanCash"]
            };
        },
        mounted: function () {
            this.getList();
            this.getWithdrawPassword()
            this.bindAlert()
        },
        methods: {
            bindAlert() {
                const v = parseInt(this.$route.query.r)
                if (v === 1) {
                    this.path='/'
                    this.$dialog.confirm({
                        mes: 'Daftar berhasil dan dapatkan bonus tunai segera setelah mengikat!',
                        title: "Tip",
                        opts: [
                            {
                                txt: "Tentu",
                                color: "#00C3F9",
                                callback: () => {
                                }
                            }
                        ]
                    })
                }
            },
            setStr(str, num) {
                return str.substring(0, num) + "****" + str.substr(str.length - num);
            },
            getList() {
                withdraw_info().then(res => {
                    // console.log('getList',res.data)
                    this.payList = res.data.bank_list; //可用银行
                    this.my_cash = res.data.my_cash; //已绑定列表
                    // console.log(' res.data.my_cash', res.data.my_cash)
                    if (res.data.my_cash != "" && res.data.my_cash != null) {
                        // console.log('aaaaa')
                        this.post.phone = this.setStr(res.data.my_cash.phone, 4)
                        this.post.bank_card = this.setStr(res.data.my_cash.bank_card, 4)
                        this.post.bank_holder = this.setStr(res.data.my_cash.bank_holder, 2)
                        this.post.sbank_name = res.data.my_cash.bank_name
                        this.post.sbank_id = Number(res.data.my_cash.bank_id)
                    } else {
                        this.my_cash = "";
                    }
                    // this.cashName = ""
                    // this.showSubmit = true
                    // this.removeData = {}
                });
            },
            submitted() {
                if (this.post.sbank_id === "") {
                    this.$dialog.toast({mes: "Please select an bind bank"});
                    return;
                }
                if (!this.post.bank_holder) {
                    this.$dialog.toast({mes: "Please enter holder name"});
                    return;
                }
                if (!this.post.bank_card) {
                    this.$dialog.toast({mes: "Please enter your bank account"});
                    return;
                }
                if (!this.post.phone) {
                    this.$dialog.toast({mes: "Please enter phone number"});
                    return;
                }
                this.$dialog.loading.open("Loading...");
                let that = this
                recharge_bind_cash(this.post)
                    .then(res => {
                        this.$dialog.loading.close();
                        // console.log('绑定账户',res)
                        /*if (res.data.moeny > 0) {
                            this.$dialog.success("Link success，You get " + this.data.icon_moeny + res.data.money) + ".";
                        } else {
                            this.$dialog.success("Link success.");
                        }

                        setTimeout(function () {
                            location.reload();
                        }, 3000)*/

                        that.$dialog.confirm({
                            mes: "Hadiah Rp"+ res.data.money+", Pergilah menghasilkan uang!",
                            title: "Tip",
                            opts: [
                                {
                                    txt: "Tentu",
                                    color: "#00C3F9",
                                    callback: () => {
                                        that.$router.replace({path: "/detail/34"})
                                    }
                                }
                            ]
                        })

                        // location.reload();
                        // this.getList()
                    })
                    .catch(res => {
                        // console.log('绑定账户错误',res)

                        this.$dialog.loading.close();
                        this.$dialog.error(res.msg);
                    });
            },
            upadte() {
                if (!this.cashName) {
                    this.$dialog.toast({mes: "Please select an cash platform"});
                    return;
                }
                if (!this.removeData.phone) {
                    this.$dialog.toast({mes: "Please enter your phone"});
                    return;
                }
                this.$dialog.loading.open("Loading...");
                recharge_ubind_cash(this.select_cash.id, {
                    phone: this.removeData.phone
                }).then(res => {
                    this.$dialog.loading.close();
                    // console.log('绑定账户',res)
                    this.$dialog.success("Link success");
                    // this.getList()
                    location.reload();
                })
                    .catch(res => {
                        this.$dialog.loading.close();
                        this.$dialog.error(res.msg);
                    });
            },
            unbindDialog() {
                this.tx_pwd_bind = !this.tx_pwd_bind
            },
            editWithdrawPasswordDialog() {
                this.tx_pwd_bind = !this.tx_pwd_bind
                this.edit_set_pwd = !this.edit_set_pwd
            },
            unbind() {
                let withdraw_pwd = this.withdraw_pwd
                if (withdraw_pwd === '')
                    return this.$dialog.error('Kata sandi penarikan tidak dapat kosong')
                if (!/^\d{6}$/.test(withdraw_pwd.trim()))
                    return this.$dialog.error('Panjang sandi tarik harus 6 digit')
                let that = this
                if (this.is_set_pwd) {
                    unbindWallet({'withdraw_pwd': withdraw_pwd}).then(res => {
                        that.$dialog.success(res.msg)
                        that.bgClose()
                        setTimeout(function () {
                            location.reload();
                        }, 500)
                    }).catch(res => {
                        that.$dialog.error(res.msg)
                    })
                } else {
                    let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                    if (confirm_withdraw_pwd !== withdraw_pwd)
                        return this.$dialog.error('Kata sandi penarikan berbeda dari kata sandi konfirmasi')
                    createWithdrawPassword({
                        'withdraw_pwd': withdraw_pwd,
                        'confirm_withdraw_pwd': confirm_withdraw_pwd
                    }).then(res => {
                        that.$dialog.success(res.msg)
                        that.bgClose()
                        setTimeout(function () {
                            location.reload();
                        }, 500)
                    }).catch(res => {
                        that.$dialog.error(res.msg)
                    })
                }
            },
            editWithdrawPassword() {
                this.tx_pwd_bind = true
                this.edit_set_pwd = true
                let old_withdraw_pwd = this.old_withdraw_pwd
                let new_withdraw_pwd = this.new_withdraw_pwd
                let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                let that = this
                if (old_withdraw_pwd === '')
                    return this.$dialog.error('Kata sandi lama tidak dapat kosong')
                if (!/^\d{6}$/.test(new_withdraw_pwd.trim()))
                    return this.$dialog.error('Kata sandi baru harus 6 digit')
                if (confirm_withdraw_pwd !== new_withdraw_pwd)
                    return this.$dialog.error('Kata sandi penarikan berbeda dari kata sandi konfirmasi')
                editWithdrawPassword({
                    'old_withdraw_pwd': old_withdraw_pwd,
                    'new_withdraw_pwd': new_withdraw_pwd,
                    'confirm_withdraw_pwd': confirm_withdraw_pwd
                }).then(res => {
                    that.$dialog.success(res.msg)
                    that.bgClose()
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            getWithdrawPassword() {
                let that = this
                getWithdrawPasswordFlag().then(res => {
                    that.is_set_pwd = res.data.flag
                    // that.is_set_pwd = false
                }).catch(res => {
                    this.$dialog.error('Silakan segar halaman');
                })
            },
            bgClose: function () {
                this.withdraw_pwd = ''
                this.confirm_withdraw_pwd = ''
                this.old_withdraw_pwd = ''
                this.new_withdraw_pwd = ''
                this.tx_pwd_bind = false
                this.edit_set_pwd = false
            },
            getPassword() {
                this.bgClose()
                this.forget_pwd = true
            },
            forgetPassword() {
                this.bgClose()
                this.forget_pwd = true
            },
            resetPwd() {
                let new_withdraw_pwd = this.new_withdraw_pwd
                let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                let forget_pwd_bank_card = this.forget_pwd_bank_card
                let that = this
                if (new_withdraw_pwd === '' || confirm_withdraw_pwd === '' || forget_pwd_bank_card === '')
                    return this.$dialog.error('Parameter tidak dapat kosong')
                if (!/^\d{6}$/.test(new_withdraw_pwd.trim()))
                    return this.$dialog.error('Kata sandi baru harus 6 digit')
                if (confirm_withdraw_pwd !== new_withdraw_pwd)
                    return this.$dialog.error('Kata sandi penarikan berbeda dari kata sandi konfirmasi')
                resetWithdrawPassword({
                    'new_withdraw_pwd': new_withdraw_pwd,
                    'confirm_withdraw_pwd': confirm_withdraw_pwd,
                    'bank_card_no': forget_pwd_bank_card
                }).then(res => {
                    that.$dialog.success(res.msg)
                    that.fpwdClose()
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            fpwdClose() {
                this.new_withdraw_pwd = ''
                this.confirm_withdraw_pwd = ''
                this.forget_pwd_bank_card = ''
                this.forget_pwd = false
            }
        }
    };
</script>
<style scoped>
    .cash-withdrawal {
        padding: 0 0.3rem;
        box-sizing: border-box;
        /*background: #FAFAFA;*/
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .value-item {
        width: 100%;
        /*height: 5rem;*/
        background: #fff;
        padding: 0.27rem 0.27rem 0 0.27rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .value-item .flex {
        display: flex;
        width: 100%;
        height: 1.2rem;
        border-bottom: 1px solid #eee;
    }

    .value-item .T1 {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .value-item .flex .I1 {
        width: 0.4rem;
        font-size: 0.85rem;
        line-height: 1.2rem;
        height: 1.2rem;
    }

    .value-item .flex input {
        width: 6rem;
        border: none;
        line-height: 1.2rem;
        height: 1.2rem;
        font-size: 0.65rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
    }

    .value-item .max {
        width: 100%;
        line-height: 1rem;
        height: 1rem;
    }

    .value-item .min {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .href {
        color: #0c7cd8;
    }

    .row-wrap {
        /*margin-bottom: 0.3rem;*/
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .submit {
        width: 100%;
        height: 0.92rem;
        background: rgba(0, 195, 249, 1);
        border-radius: 7px;
        color: #fff;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.35rem;
        margin-top: 1rem;
    }

    .tips {
        margin-top: 10px;
        color: #999;
    }

    .unbind {
        background: #CCC !important;
    }

    #fpwd, #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .set-pwd {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .set-tx-pwd-btn {
        display: block;
        width: 2.5rem;
        height: 0.86rem;
        margin: 0.2rem;
        float: left;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .bg-qx {
        background-color: #f0f1f3;
    }

    .tx-pwd-title {
        font-weight: bold;
        text-align: center;
    }

    .forget-password {
        color: #ddd;
        text-align: right;
        padding-right: 0.2rem;
    }
</style>